// NOTE (Phase C / TASK_003 — 2026-06-07):
// The frontend no longer maintains its own admin allow-list. The backend is the
// single source of truth for ``isGlobalAdmin`` — it resolves
// ``env GLOBAL_ADMIN_EMAILS`` + the ``global_admins`` DB table against the
// authenticated ``Principal`` (see ``backend/app/core/global_admin.py``) and
// exposes the resulting flag through ``GET /api/global-admins/me`` (and via the
// dev-login profile payload). The frontend just reads that flag and trusts it.
//
// Consequence: ``deriveGlobalAdminStatus`` now collapses to
// ``Boolean(profileFlag)``. The old ``DEFAULT_GLOBAL_ADMIN_EMAILS`` /
// ``envGlobalAdmins`` / ``backendGlobalAdmins`` / ``extraGlobalAdmins`` inputs
// are gone. ``deriveApprovalStatus`` also no longer special-cases an admin
// email list — it leans on the resolved ``profileFlag``.

export function parseEmailList(value?: string): string[] {
  return (
    value
      ?.split(',')
      .map((email) => email.trim().toLowerCase())
      .filter(Boolean) || []
  )
}

export function deriveGlobalAdminStatus({
  profileFlag,
}: {
  profileFlag?: boolean
}): boolean {
  return Boolean(profileFlag)
}

export function deriveApprovalStatus({
  email,
  profileFlag,
  isDemo,
  envApprovedEmails,
  isGlobalAdmin,
}: {
  email?: string | null
  profileFlag?: boolean
  isDemo?: boolean
  envApprovedEmails: string[]
  isGlobalAdmin: (email?: string | null, profileFlag?: boolean) => boolean
}): boolean {
  if (isDemo) return true
  const normalized = email?.toLowerCase() || ''
  if (!normalized) return false
  if (isGlobalAdmin(normalized, profileFlag)) return true
  return envApprovedEmails.includes(normalized)
}
